import FormatBold from '@mui/icons-material/FormatBold';
import FormatItalic from '@mui/icons-material/FormatItalic';
import FormatListBulleted from '@mui/icons-material/FormatListBulleted';
import FormatStrikethrough from '@mui/icons-material/FormatStrikethrough';
import FormatUnderlined from '@mui/icons-material/FormatUnderlined';
import Link from '@mui/icons-material/Link';
import LinkOff from '@mui/icons-material/LinkOff';
import { IconButton, Paper, Tooltip } from '@mui/material';
import {
  BubbleMenu,
  bubbleMenuMouseDownHandler,
  bubbleMenuShouldShow,
  type Editor,
  getToolbarButtons,
  KEY_SHORTCUTS_MAC,
  KEY_SHORTCUTS_WINDOWS,
} from '@provision/rich-text-editor';
import type { ElementType } from 'react';

// `getToolbarButtons` names its icons by Material Symbols name.
const ICONS: Record<string, ElementType> = {
  format_bold: FormatBold,
  format_italic: FormatItalic,
  format_underlined: FormatUnderlined,
  format_strikethrough: FormatStrikethrough,
  format_list_bulleted: FormatListBulleted,
  link: Link,
  link_off: LinkOff,
};

const isMac = typeof navigator !== 'undefined' && /Mac/i.test(navigator.userAgent);

interface FormatBarProps {
  editor: Editor;
  onLinkClick: () => void;
}

export const FormatBar = ({ editor, onLinkClick }: FormatBarProps) => {
  const { formatting } = getToolbarButtons({
    editor,
    keyShortcuts: isMac ? KEY_SHORTCUTS_MAC : KEY_SHORTCUTS_WINDOWS,
    onLinkClick,
  });

  return (
    <BubbleMenu editor={editor} shouldShow={bubbleMenuShouldShow}>
      <Paper
        elevation={3}
        onMouseDown={bubbleMenuMouseDownHandler}
        sx={{ display: 'flex', gap: 0.25, p: 0.5 }}
      >
        {formatting.map((button) => {
          const Icon = ICONS[button.icon];

          return (
            <Tooltip key={button.title} title={button.title}>
              <IconButton
                size="small"
                aria-label={button.title}
                color={button.isActive ? 'primary' : 'default'}
                disabled={button.disabled}
                onClick={button.onClick}
              >
                {Icon ? <Icon fontSize="small" /> : null}
              </IconButton>
            </Tooltip>
          );
        })}
      </Paper>
    </BubbleMenu>
  );
};
